<div class="table-page fraud-case" dir="rtl">
  <app-fraud-case-summary [caseId]="caseId" [detail]="detail" [loading]="loading" [error]="error" (retry)="loadCase()">
  </app-fraud-case-summary>

  <ng-container *ngIf="detail">
    <app-fraud-case-evidence [items]="evidence" [loading]="evidenceLoading" [error]="evidenceError" (retry)="loadEvidence()">
    </app-fraud-case-evidence>

    <app-fraud-case-routes [firstUnitId]="detail.strUnitID1" [secondUnitId]="detail.strUnitID2"
      [points]="routePoints" [loading]="routesLoading" [error]="routesError" (loadRequested)="loadRoutes()">
    </app-fraud-case-routes>

    <app-fraud-case-review [(status)]="reviewStatus" [(comment)]="reviewComment" [saving]="saving"
      [error]="reviewError" [success]="reviewSuccess" (saveRequested)="saveReview()">
    </app-fraud-case-review>
  </ng-container>
</div>
